// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./TaskTypeManagementPage.css";

// const PRIORITY_VALUES = ["low", "normal", "high"];

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   category_required: false,
//   subcategory_required: false,
//   project_allowed: false,
//   project_required: false,
//   project_module_allowed: false,
//   project_module_required: false,
//   attachment_allowed: true,
//   default_priority: "",
//   display_order: "",
// };

// const FLAG_LABELS = [
//   ["category_required", "Category required"],
//   ["subcategory_required", "Subcategory required"],
//   ["project_allowed", "Project allowed"],
//   ["project_required", "Project required"],
//   ["project_module_allowed", "Module allowed"],
//   ["project_module_required", "Module required"],
//   ["attachment_allowed", "Attachments allowed"],
// ];

// export default function TaskTypeManagementPage() {
//   const { can } = usePermissions();

//   const [taskTypes, setTaskTypes] = useState([]);
//   const [total, setTotal] = useState(0);

//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [systemFilter, setSystemFilter] = useState("");

//   const [sortField, setSortField] = useState("display_order");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(20);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [editIsSystem, setEditIsSystem] = useState(false);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     fetchTaskTypes();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, statusFilter, systemFilter, sortField, sortOrder, currentPage, pageSize]);

//   const fetchTaskTypes = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/task-types", {
//         params: {
//           search: search || undefined,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           is_system: systemFilter === "" ? undefined : systemFilter,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setTaskTypes(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch task types error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch task types");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setEditIsSystem(false);
//     setShowModal(true);
//   };

//   const openEdit = (taskType) => {
//     setForm({
//       name: taskType.name || "",
//       code: taskType.code || "",
//       description: taskType.description || "",
//       category_required: !!taskType.category_required,
//       subcategory_required: !!taskType.subcategory_required,
//       project_allowed: !!taskType.project_allowed,
//       project_required: !!taskType.project_required,
//       project_module_allowed: !!taskType.project_module_allowed,
//       project_module_required: !!taskType.project_module_required,
//       attachment_allowed: !!taskType.attachment_allowed,
//       default_priority: taskType.default_priority || "",
//       display_order: taskType.display_order ?? "",
//     });
//     setEditId(taskType.id);
//     setEditIsSystem(!!taskType.is_system);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setEditIsSystem(false);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Task type name is required");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       description: form.description.trim() || null,
//       category_required: form.category_required,
//       subcategory_required: form.subcategory_required,
//       project_allowed: form.project_allowed,
//       project_required: form.project_required,
//       project_module_allowed: form.project_module_allowed,
//       project_module_required: form.project_module_required,
//       attachment_allowed: form.attachment_allowed,
//       default_priority: form.default_priority || null,
//       display_order: form.display_order === "" ? 0 : Number(form.display_order),
//     };

//     if (!editId) {
//       payload.code = form.code.trim() || undefined;
//     }

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/task-types/${editId}`, payload);
//         toast.success("Task type updated");
//       } else {
//         await api.post("/task-types", payload);
//         toast.success("Task type created");
//       }
//       closeModal();
//       fetchTaskTypes();
//     } catch (err) {
//       console.error("Save task type error:", err);
//       toast.error(err.response?.data?.message || "Failed to save task type");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (taskType) => {
//     try {
//       await api.patch(`/task-types/${taskType.id}/status`, { is_active: !taskType.is_active });
//       toast.success(taskType.is_active ? "Task type deactivated" : "Task type activated");
//       fetchTaskTypes();
//     } catch (err) {
//       console.error("Toggle status error:", err);
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const openDeleteModal = (taskType) => {
//     setDeleteTarget(taskType);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/task-types/${deleteTarget.id}`);
//       toast.success("Task type deleted");
//       closeDeleteModal();
//       fetchTaskTypes();
//     } catch (err) {
//       console.error("Delete task type error:", err);
//       const data = err.response?.data;
//       if (data?.code === "TASK_TYPE_IN_USE") {
//         toast.error(`Cannot delete: ${data.details?.tasks || 0} task(s) use this type. Deactivate instead.`);
//       } else if (data?.code === "TASK_TYPE_SYSTEM_PROTECTED") {
//         toast.error("This task type is protected and cannot be deleted.");
//       } else {
//         toast.error(data?.message || "Failed to delete task type");
//       }
//       closeDeleteModal();
//     }
//   };

//   const activeFlags = useMemo(
//     () => (taskType) => FLAG_LABELS.filter(([key]) => taskType[key]).map(([, label]) => label),
//     []
//   );

//   return (
//     <div className="unit-page tasktype-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Task Type Management</h2>
//           <p>Configure task types used across IT support, projects and general work. Task types are never hardcoded.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchTaskTypes}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="task_types" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Task Type
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="tasktype-stat-icon tasktype-stat-icon-primary">
//             <i className="fa-solid fa-tags" aria-hidden="true"></i>
//           </div>
//           <div className="tasktype-stat-text">
//             <span>Total Task Types</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="tasktype-stat-icon tasktype-stat-icon-success">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="tasktype-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-list-check tasktype-list-icon" aria-hidden="true"></i>
//               Task Type List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete task types.</p>
//           </div>

//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 240 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search task type name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <Form.Select
//               style={{ maxWidth: 150 }}
//               value={statusFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setStatusFilter(e.target.value);
//               }}
//             >
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 170 }}
//               value={systemFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setSystemFilter(e.target.value);
//               }}
//             >
//               <option value="">System: Any</option>
//               <option value="1">System only</option>
//               <option value="0">Non-system only</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               style={{ maxWidth: 120 }}
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading task types...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
//                   <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
//                   <th>Configuration</th>
//                   <th>System</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {taskTypes.length > 0 ? (
//                   taskTypes.map((taskType) => (
//                     <tr key={taskType.id}>
//                       <td><strong>{taskType.name}</strong></td>
//                       <td>
//                         {taskType.code}
//                         {taskType.is_system && (
//                           <>
//                             <br />
//                             <small className="text-muted">Code is protected — cannot be changed</small>
//                           </>
//                         )}
//                       </td>
//                       <td>
//                         {activeFlags(taskType).map((label) => (
//                           <Badge key={label} bg="light" text="dark" className="me-1 mb-1">
//                             {label}
//                           </Badge>
//                         ))}
//                       </td>
//                       <td>
//                         {taskType.is_system ? <Badge bg="warning" text="dark">System</Badge> : <span className="tasktype-muted">—</span>}
//                       </td>
//                       <td>
//                         <Badge className={`unit-status${taskType.is_active ? "" : " unit-status-inactive"}`}>
//                           {taskType.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="task_types" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${taskType.name || "task type"}`}
//                               onClick={() => openEdit(taskType)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("task_types", "activate") || can("task_types", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn tasktype-toggle"
//                               title={taskType.is_active ? "Deactivate" : "Activate"}
//                               aria-label={`${taskType.is_active ? "Deactivate" : "Activate"} ${taskType.name || "task type"}`}
//                               onClick={() => toggleStatus(taskType)}
//                               disabled={taskType.is_system && taskType.is_active}
//                             >
//                               <i className={`fa-solid ${taskType.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="task_types" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title={taskType.is_system ? "Protected — cannot be deleted" : "Delete"}
//                               aria-label={taskType.is_system ? "Protected — cannot be deleted" : `Delete ${taskType.name || "task type"}`}
//                               onClick={() => openDeleteModal(taskType)}
//                               disabled={taskType.is_system}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="6">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-tags" aria-hidden="true"></i>
//                         </div>
//                         <h5>No task types found</h5>
//                         <p>Try another search or add a new task type.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{taskTypes.length}</strong> of <strong>{total}</strong> task types
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal show={showModal} onHide={closeModal} centered className="unit-modal" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>{editId ? "Edit Task Type" : "Add New Task Type"}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. Development Task"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
//               <Form.Control
//                 placeholder="e.g. DEVELOPMENT"
//                 value={form.code}
//                 disabled={!!editId}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//               {editIsSystem && <Form.Text className="text-danger">This is a protected system task type.</Form.Text>}
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Default Priority (optional)</Form.Label>
//               <Form.Select value={form.default_priority} onChange={(e) => handleChange("default_priority", e.target.value)}>
//                 <option value="">Not set</option>
//                 {PRIORITY_VALUES.map((p) => <option key={p} value={p}>{p}</option>)}
//               </Form.Select>
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Display Order</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.display_order}
//                 onChange={(e) => handleChange("display_order", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label className="d-block">Configuration Flags</Form.Label>
//               <div className="d-flex flex-wrap gap-3">
//                 {FLAG_LABELS.map(([key, label]) => (
//                   <Form.Check
//                     key={key}
//                     type="checkbox"
//                     label={label}
//                     checked={!!form[key]}
//                     onChange={(e) => handleChange(key, e.target.checked)}
//                   />
//                 ))}
//               </div>
//               <Form.Text muted>
//                 "Required" flags are only meaningful when their matching "allowed" flag is also on.
//               </Form.Text>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Task Type" : "Create Task Type"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal show={showDeleteModal} onHide={closeDeleteModal} centered className="unit-modal">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Task Type</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If tasks reference it, deletion will be blocked — deactivate it instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>Delete</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }



import React, { useEffect, useMemo, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "./TaskTypeManagementPage.css";

const PRIORITY_VALUES = ["low", "normal", "high"];

const initialForm = {
  name: "",
  code: "",
  description: "",
  category_required: false,
  subcategory_required: false,
  project_allowed: false,
  project_required: false,
  project_module_allowed: false,
  project_module_required: false,
  attachment_allowed: true,
  default_priority: "",
  display_order: "",
};

const FLAG_LABELS = [
  ["category_required", "Category required"],
  ["subcategory_required", "Subcategory required"],
  ["project_allowed", "Project allowed"],
  ["project_required", "Project required"],
  ["project_module_allowed", "Module allowed"],
  ["project_module_required", "Module required"],
  ["attachment_allowed", "Attachments allowed"],
];

// Purely presentational grouping of the same FLAG_LABELS flags already on
// the row -- "Allowed" vs "Required" chip groups instead of one flat pill
// list, plus a short label (suffix stripped) for the chip text. Derived
// only from key naming already established above; does not add/rename any
// underlying field.
const shortFlagLabel = (label) => label.replace(/ (allowed|required)$/i, "");

const configGroupsFor = (taskType) => {
  const allowed = [];
  const required = [];
  FLAG_LABELS.forEach(([key, label]) => {
    if (!taskType[key]) return;
    if (key.endsWith("_allowed")) allowed.push(shortFlagLabel(label));
    else if (key.endsWith("_required")) required.push(shortFlagLabel(label));
  });
  return { allowed, required };
};

const CONFIG_CHIP_LIMIT = 3;

export default function TaskTypeManagementPage() {
  const { can } = usePermissions();

  const [taskTypes, setTaskTypes] = useState([]);
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [systemFilter, setSystemFilter] = useState("");

  const [sortField, setSortField] = useState("display_order");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [editIsSystem, setEditIsSystem] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // UI-only: which row's configuration detail panel is expanded. Purely
  // presentational -- does not affect fetch/filter/sort state or trigger
  // any request.
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    fetchTaskTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter, systemFilter, sortField, sortOrder, currentPage, pageSize]);

  const fetchTaskTypes = async () => {
    try {
      setLoading(true);
      const res = await api.get("/task-types", {
        params: {
          search: search || undefined,
          is_active: statusFilter === "" ? undefined : statusFilter,
          is_system: systemFilter === "" ? undefined : systemFilter,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });
      setTaskTypes(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch task types error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch task types");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setEditIsSystem(false);
    setShowModal(true);
  };

  const openEdit = (taskType) => {
    setForm({
      name: taskType.name || "",
      code: taskType.code || "",
      description: taskType.description || "",
      category_required: !!taskType.category_required,
      subcategory_required: !!taskType.subcategory_required,
      project_allowed: !!taskType.project_allowed,
      project_required: !!taskType.project_required,
      project_module_allowed: !!taskType.project_module_allowed,
      project_module_required: !!taskType.project_module_required,
      attachment_allowed: !!taskType.attachment_allowed,
      default_priority: taskType.default_priority || "",
      display_order: taskType.display_order ?? "",
    });
    setEditId(taskType.id);
    setEditIsSystem(!!taskType.is_system);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setEditIsSystem(false);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Task type name is required");
      return;
    }

    const payload = {
      name: form.name.trim(),
      description: form.description.trim() || null,
      category_required: form.category_required,
      subcategory_required: form.subcategory_required,
      project_allowed: form.project_allowed,
      project_required: form.project_required,
      project_module_allowed: form.project_module_allowed,
      project_module_required: form.project_module_required,
      attachment_allowed: form.attachment_allowed,
      default_priority: form.default_priority || null,
      display_order: form.display_order === "" ? 0 : Number(form.display_order),
    };

    if (!editId) {
      payload.code = form.code.trim() || undefined;
    }

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/task-types/${editId}`, payload);
        toast.success("Task type updated");
      } else {
        await api.post("/task-types", payload);
        toast.success("Task type created");
      }
      closeModal();
      fetchTaskTypes();
    } catch (err) {
      console.error("Save task type error:", err);
      toast.error(err.response?.data?.message || "Failed to save task type");
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (taskType) => {
    try {
      await api.patch(`/task-types/${taskType.id}/status`, { is_active: !taskType.is_active });
      toast.success(taskType.is_active ? "Task type deactivated" : "Task type activated");
      fetchTaskTypes();
    } catch (err) {
      console.error("Toggle status error:", err);
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const openDeleteModal = (taskType) => {
    setDeleteTarget(taskType);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/task-types/${deleteTarget.id}`);
      toast.success("Task type deleted");
      closeDeleteModal();
      fetchTaskTypes();
    } catch (err) {
      console.error("Delete task type error:", err);
      const data = err.response?.data;
      if (data?.code === "TASK_TYPE_IN_USE") {
        toast.error(`Cannot delete: ${data.details?.tasks || 0} task(s) use this type. Deactivate instead.`);
      } else if (data?.code === "TASK_TYPE_SYSTEM_PROTECTED") {
        toast.error("This task type is protected and cannot be deleted.");
      } else {
        toast.error(data?.message || "Failed to delete task type");
      }
      closeDeleteModal();
    }
  };

  const activeFlags = useMemo(
    () => (taskType) => FLAG_LABELS.filter(([key]) => taskType[key]).map(([, label]) => label),
    []
  );

  return (
    <div className="unit-page tasktype-mgmt-theme">

      <div className="tasktype-heading-box">
        <div className="tasktype-heading-content">
          <div className="tasktype-heading-icon">
            <i className="fa-solid fa-list-check" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Task Type Management</h2>
            <p>Configure task types used across IT support, projects and general work. Task types are never hardcoded.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchTaskTypes}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="task_types" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Task Type
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card tasktype-stat-blue">
          <div className="tasktype-stat-content">
            <div className="tasktype-stat-text">
              <span>Total Task Types</span>
              <strong>{total}</strong>
            </div>

            <div className="tasktype-stat-icon">
              <i className="fa-solid fa-tags" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card tasktype-stat-purple">
          <div className="tasktype-stat-content">
            <div className="tasktype-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="tasktype-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card tasktype-stat-green">
          <div className="tasktype-stat-content">
            <div className="tasktype-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="tasktype-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar tasktype-toolbar">
          <div className="tasktype-section-title">
            <div className="tasktype-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="tasktype-section-copy">
              <h5>Task Type List</h5>
              <p>Search, filter, add, update, activate/deactivate or delete task types.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions tasktype-filters-row">
            <InputGroup className="unit-search tasktype-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search task type name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <div className="tasktype-select-wrap">
              <i className="fa-solid fa-circle-check tasktype-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="tasktype-filter-select"
                aria-label="Filter by status"
                value={statusFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setStatusFilter(e.target.value);
              }}
            >
              <option value="">All Statuses</option>
              <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </div>

            <div className="tasktype-select-wrap">
              <i className="fa-solid fa-shield-halved tasktype-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="tasktype-filter-select"
                aria-label="Filter by system type"
                value={systemFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setSystemFilter(e.target.value);
              }}
            >
              <option value="">System: Any</option>
              <option value="1">System only</option>
                <option value="0">Non-system only</option>
              </Form.Select>
            </div>

            <Form.Select
              className="unit-page-size"
              aria-label="Rows per page"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>

            {(search || statusFilter || systemFilter) && (
              <Button
                className="unit-btn unit-btn-light"
                onClick={() => {
                  setCurrentPage(1);
                  setSearch("");
                  setStatusFilter("");
                  setSystemFilter("");
                }}
              >
                <i className="fa-solid fa-rotate-left" aria-hidden="true"></i>
                Clear Filters
              </Button>
            )}
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading task types...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
                  <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
                  <th>Configuration</th>
                  <th>System</th>
                  <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {taskTypes.length > 0 ? (
                  taskTypes.map((taskType) => {
                    const { allowed, required } = configGroupsFor(taskType);
                    const totalFlags = allowed.length + required.length;
                    const isExpanded = expandedId === taskType.id;
                    const fullConfigTitle = activeFlags(taskType).join(", ") || "No configuration flags set";

                    return (
                      <React.Fragment key={taskType.id}>
                        <tr>
                          <td>
                            <div className="tasktype-name-box">
                              <button
                                type="button"
                                className={`tasktype-expand-btn${isExpanded ? " tasktype-expand-btn-open" : ""}`}
                                onClick={() => setExpandedId(isExpanded ? null : taskType.id)}
                                title={isExpanded ? "Collapse details" : "Expand details"}
                                aria-label={`${isExpanded ? "Collapse" : "Expand"} configuration details for ${taskType.name || "task type"}`}
                                aria-expanded={isExpanded}
                              >
                                <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>
                              </button>

                              <div className="tasktype-letter">
                                {taskType.name?.charAt(0)?.toUpperCase() || "T"}
                              </div>

                              <div className="tasktype-name-copy">
                                <strong title={taskType.name}>{taskType.name}</strong>
                                <small>Task Type ID: {taskType.id}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="tasktype-code-wrap">
                              <span className="tasktype-code-chip">
                                <i className="fa-solid fa-code" aria-hidden="true"></i>
                                {taskType.code || "—"}
                              </span>

                              {taskType.is_system && (
                                <small className="tasktype-protected-note">
                                  <i className="fa-solid fa-lock" aria-hidden="true"></i>
                                  Protected code
                                </small>
                              )}
                            </div>
                          </td>
                          <td>
                            {totalFlags > 0 ? (
                              <div className="tasktype-config-cell" title={fullConfigTitle}>
                                {allowed.length > 0 && (
                                  <div className="tasktype-config-group">
                                    <span className="tasktype-config-group-label">Allowed</span>
                                    <div className="tasktype-flags-wrap">
                                      {allowed.slice(0, CONFIG_CHIP_LIMIT).map((label) => (
                                        <span key={label} className="tasktype-flag-chip">
                                          <i className="fa-solid fa-check" aria-hidden="true"></i>
                                          {label}
                                        </span>
                                      ))}
                                      {allowed.length > CONFIG_CHIP_LIMIT && (
                                        <span className="tasktype-flag-chip tasktype-flag-more">
                                          +{allowed.length - CONFIG_CHIP_LIMIT} More
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {required.length > 0 && (
                                  <div className="tasktype-config-group">
                                    <span className="tasktype-config-group-label">Required</span>
                                    <div className="tasktype-flags-wrap">
                                      {required.slice(0, CONFIG_CHIP_LIMIT).map((label) => (
                                        <span key={label} className="tasktype-flag-chip tasktype-flag-chip-required">
                                          <i className="fa-solid fa-check" aria-hidden="true"></i>
                                          {label}
                                        </span>
                                      ))}
                                      {required.length > CONFIG_CHIP_LIMIT && (
                                        <span className="tasktype-flag-chip tasktype-flag-more">
                                          +{required.length - CONFIG_CHIP_LIMIT} More
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <span className="tasktype-muted">No flags</span>
                            )}
                          </td>
                          <td>
                            {taskType.is_system ? (
                              <Badge className="unit-status tasktype-system-badge">
                                <i className="fa-solid fa-shield-halved me-1" aria-hidden="true"></i>
                                System
                              </Badge>
                            ) : (
                              <span className="tasktype-custom-chip">
                                <i className="fa-solid fa-pen-ruler" aria-hidden="true"></i>
                                Custom
                              </span>
                            )}
                          </td>
                          <td>
                            <Badge
                              className={`unit-status ${
                                taskType.is_active
                                  ? "tasktype-status-active"
                                  : "tasktype-status-inactive"
                              }`}
                            >
                              <i
                                className={
                                  taskType.is_active
                                    ? "fa-solid fa-circle-check me-1"
                                    : "fa-solid fa-circle-pause me-1"
                                }
                                aria-hidden="true"
                              ></i>
                              {taskType.is_active ? "Active" : "Inactive"}
                            </Badge>
                          </td>
                          <td>
                            <div className="unit-actions">
                              <Can moduleKey="task_types" actionKey="edit">
                                <Button
                                  className="unit-icon-btn unit-edit"
                                  title="Edit"
                                  aria-label={`Edit ${taskType.name || "task type"}`}
                                  onClick={() => openEdit(taskType)}
                                >
                                  <i className="fa-solid fa-pen" aria-hidden="true"></i>
                                </Button>
                              </Can>

                              {(can("task_types", "activate") || can("task_types", "deactivate")) && (
                                <Button
                                  className={`unit-icon-btn tasktype-toggle ${
                                    taskType.is_active
                                      ? "tasktype-toggle-off"
                                      : "tasktype-toggle-on"
                                  }`}
                                  title={taskType.is_active ? "Deactivate" : "Activate"}
                                  aria-label={`${taskType.is_active ? "Deactivate" : "Activate"} ${taskType.name || "task type"}`}
                                  onClick={() => toggleStatus(taskType)}
                                  disabled={taskType.is_system && taskType.is_active}
                                >
                                  <i className={`fa-solid ${taskType.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                                </Button>
                              )}

                              <Can moduleKey="task_types" actionKey="delete">
                                <Button
                                  className="unit-icon-btn unit-delete"
                                  title={taskType.is_system ? "Protected — cannot be deleted" : "Delete"}
                                  aria-label={taskType.is_system ? "Protected — cannot be deleted" : `Delete ${taskType.name || "task type"}`}
                                  onClick={() => openDeleteModal(taskType)}
                                  disabled={taskType.is_system}
                                >
                                  <i className="fa-solid fa-trash" aria-hidden="true"></i>
                                </Button>
                              </Can>
                            </div>
                          </td>
                        </tr>

                        {isExpanded && (
                          <tr className="tasktype-expand-row">
                            <td colSpan="6">
                              <div className="tasktype-expand-panel">
                                {[
                                  ["project_allowed", "Project Allowed"],
                                  ["project_required", "Project Required"],
                                  ["project_module_allowed", "Module Allowed"],
                                  ["project_module_required", "Module Required"],
                                  ["attachment_allowed", "Attachments Allowed"],
                                ].map(([key, label]) => (
                                  <div
                                    key={key}
                                    className={`tasktype-expand-item${taskType[key] ? " tasktype-expand-item-on" : ""}`}
                                  >
                                    <span className="tasktype-expand-dot" aria-hidden="true"></span>
                                    <span className="tasktype-expand-label">{label}</span>
                                    <i
                                      className={`fa-solid ${taskType[key] ? "fa-circle-check" : "fa-circle-xmark"}`}
                                      aria-hidden="true"
                                    ></i>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-tags" aria-hidden="true"></i>
                        </div>
                        <h5>No task types found</h5>
                        <p>Try another search or add a new task type.</p>

                        <Can moduleKey="task_types" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Task Type
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{taskTypes.length}</strong> of <strong>{total}</strong> task types
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        size="lg"
        dialogClassName="tasktype-admin-modal tasktype-admin-modal-lg tasktype-mgmt-theme tasktype-drawer"
        backdropClassName="tasktype-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="tasktype-modal-heading">
            <div className="tasktype-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-list-check"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Task Type Setup</small>
              <Modal.Title>{editId ? "Edit Task Type" : "Add New Task Type"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Label>Name</Form.Label>
              <div className="tasktype-modal-field">
                <i className="fa-solid fa-list-check" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. Development Task"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
              <div className="tasktype-modal-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. DEVELOPMENT"
                  value={form.code}
                  disabled={!!editId}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
              {editIsSystem && (
                <Form.Text className="tasktype-system-warning">
                  <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
                  This is a protected system task type.
                </Form.Text>
              )}
            </div>

            <div className="col-md-12">
              <Form.Label>Description</Form.Label>
              <div className="tasktype-modal-field tasktype-modal-field-textarea">
                <i className="fa-regular fa-note-sticky" aria-hidden="true"></i>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-4">
              <Form.Label>Default Priority (optional)</Form.Label>
              <Form.Select value={form.default_priority} onChange={(e) => handleChange("default_priority", e.target.value)}>
                <option value="">Not set</option>
                {PRIORITY_VALUES.map((p) => <option key={p} value={p}>{p}</option>)}
              </Form.Select>
            </div>

            <div className="col-md-4">
              <Form.Label>Display Order</Form.Label>
              <Form.Control
                type="number"
                value={form.display_order}
                onChange={(e) => handleChange("display_order", e.target.value)}
              />
            </div>

            <div className="col-md-12">
              <div className="tasktype-flags-heading">
                <div>
                  <Form.Label className="d-block">Configuration Flags</Form.Label>
                  <small>Control which task fields are allowed or required.</small>
                </div>
              </div>
              <div className="tasktype-config-grid">
                {FLAG_LABELS.map(([key, label]) => (
                  <Form.Check
                    key={key}
                    className="tasktype-config-check"
                    type="checkbox"
                    label={label}
                    checked={!!form[key]}
                    onChange={(e) => handleChange(key, e.target.checked)}
                  />
                ))}
              </div>
              <Form.Text muted>
                "Required" flags are only meaningful when their matching "allowed" flag is also on.
              </Form.Text>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Task Type" : "Create Task Type"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="tasktype-admin-modal tasktype-admin-modal-sm tasktype-admin-modal-danger tasktype-mgmt-theme"
        backdropClassName="tasktype-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="tasktype-modal-heading">
            <div className="tasktype-modal-icon tasktype-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Task Type</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="tasktype-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-list-check"></i>
          </div>

          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If tasks reference it, deletion will be blocked — deactivate it instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}